"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _conditions = require("./data/conditions");

var _QuestionRenderer = _interopRequireDefault(require("./QuestionRenderer"));

var _defaultValues = require("./data/defaultValues");

var _validation = require("./data/validation");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}

function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || typeof obj !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache(nodeInterop);

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

var SurveyRenderer = function SurveyRenderer(_ref) {
  var questions = _ref.questions,
      setResponse = _ref.setResponse,
      setIsResponseValid = _ref.setIsResponseValid,
      showErrors = _ref.showErrors;

  var _useState = (0, _react.useState)(questions.map(function (x) {
    return {
      questionId: x.id,
      type: x.component.type,
      value: (0, _defaultValues.getDefaultQuestionResponse)(x.component.type)
    };
  })),
      values = _useState[0],
      setValues = _useState[1];

  var _useState2 = (0, _react.useState)([]),
      invalidResponses = _useState2[0],
      setInvalidResponses = _useState2[1];

  (0, _react.useEffect)(function () {
    var validation = (0, _validation.validateResponses)(values, questions);
    setResponse(values);
    setIsResponseValid(validation.isValid);
    setInvalidResponses(validation.invalidResponses);
  }, [values]);

  var setQuestionValue = function setQuestionValue(id, type, value) {
    var newValues = [].concat(values.filter(function (x) {
      return x.questionId !== id;
    }), [{
      questionId: id,
      type: type,
      value: value
    }]);
    var parsedValues = newValues.map(function (v) {
      return Object.assign({}, v, {
        value: (0, _conditions.resolveQuestionConditions)(newValues, questions.filter(function (q) {
          return q.id === v.questionId;
        })[0].conditions) ? v.value : (0, _defaultValues.getDefaultQuestionResponse)(questions.filter(function (q) {
          return q.id === v.questionId;
        })[0].component.type)
      });
    });
    setValues(parsedValues);
  };

  var questionsToRender = questions.map(function (x) {
    return Object.assign({}, x, {
      display: (0, _conditions.resolveQuestionConditions)(values, x.conditions)
    });
  }).filter(function (y) {
    return y.display;
  }).sort(function (a, b) {
    return a.position - b.position;
  });
  return /*#__PURE__*/_react.default.createElement("div", null, questionsToRender.map(function (x, i) {
    var _values$filter$;

    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, x.sectionTitle && /*#__PURE__*/_react.default.createElement("h6", {
      className: "ln-u-flush"
    }, x.sectionTitle), x.sectionDescription && /*#__PURE__*/_react.default.createElement("p", {
      className: "ln-u-margin-bottom*3"
    }, x.sectionDescription), /*#__PURE__*/_react.default.createElement("div", {
      key: x.id + "-questionRenderer"
    }, /*#__PURE__*/_react.default.createElement(_QuestionRenderer.default, {
      question: x,
      number: i + 1,
      hideNumbers: x.hideNumbers,
      value: (_values$filter$ = values.filter(function (y) {
        return y.questionId === x.id;
      })[0]) == null ? void 0 : _values$filter$.value,
      setValue: setQuestionValue,
      error: invalidResponses.filter(function (y) {
        return y.questionId === x.id;
      }).length > 0 && showErrors
    })));
  }));
};

SurveyRenderer.propTypes = {
  /** Array containing the information of each question */
  questions: _propTypes.default.arrayOf(_propTypes.default.shape({
    /** The unique identifier of the question */
    id: _propTypes.default.string,

    /** The position of the question in the survey */
    position: _propTypes.default.number,

    /** The title of the question */
    title: _propTypes.default.string,

    /** Whether to hide the question numbers */
    hideNumbers: _propTypes.default.bool,

    /** The supporting description of the question */
    description: _propTypes.default.string,

    /** The supporting section description of the question */
    sectionTitle: _propTypes.default.string,

    /** The supporting subsection description of the question */
    sectionDescription: _propTypes.default.string,

    /** The conditions a question has to be displayed */
    conditions: _propTypes.default.array,

    /** Information on the component to be rendered for the question */
    component: _propTypes.default.shape({
      /** The type of component the question should render */
      type: _propTypes.default.string,

      /** The props to be passed to the rendered question component */
      props: _propTypes.default.object
    })
  })).isRequired,

  /** Sets the response value of the survey */
  setResponse: _propTypes.default.func.isRequired,

  /** Sets whether the survey is valid for completion based on the responses */
  setIsResponseValid: _propTypes.default.func.isRequired,

  /** Controls whether errors should be displayed on questions that have an invalid response */
  showErrors: _propTypes.default.bool.isRequired
};
var _default = SurveyRenderer;
exports.default = _default;